import { render, staticRenderFns } from "./LessonCategoryOrders.vue?vue&type=template&id=6ef67991"
import script from "./LessonCategoryOrders.vue?vue&type=script&lang=js"
export * from "./LessonCategoryOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports